import React, { useEffect } from "react";
import { VectorMap } from "react-jvectormap";


const DashboardWorldMap = ({participants,callback}) => {
  const mapData = {};

    const _buildMapData = ()=>{

      if(!participants) return;
      participants.forEach((obj)=>{
        var countryCode = obj?.livingcountry?.code;

        if(countryCode==="KU") countryCode = "IR"
        if(countryCode==="KBS") countryCode = "IQ"
        if(countryCode==="KBK") countryCode = "TR"
        if(countryCode==="KRJ") countryCode = "SY"
        
        if(mapData[countryCode]!== undefined){
          mapData[countryCode]=mapData[countryCode]+1
        }
        else
        mapData[countryCode]=1

      }
      );

    }
    _buildMapData()

    const handleClick = (e, countryCode) => {
      callback(countryCode  ,mapData[countryCode] ? mapData[countryCode] : 0);
    };
  

  return (
    <div >
      <VectorMap
        map={"world_mill"}
        backgroundColor="#0077be" //change it to ocean blue: #0077be
        zoomOnScroll={true}
        containerStyle={{
          width: "100%",
          height: "400px"
        }}
        onRegionClick={handleClick} //gets the country code
        containerClassName="map"
        regionStyle={{
          initial: {
            fill: "#e4e4e4",
            "fill-opacity": 0.9,
            stroke: "none",
            "stroke-width": 0,
            "stroke-opacity": 0
          },
          hover: {
            "fill-opacity": 0.8,
            cursor: "pointer"
          },
          selected: {
          },
          selectedHover: {}
        }}
        regionsSelectable={false}
        series={{
          regions: [
            {
              values: mapData, //this is your data
              scale: ["#e2f868", "#f36565"], //your color game's here
              normalizeFunction: "polynomial"
            }
          ]
        }}
      />
    </div>
  );
};
export default DashboardWorldMap;